<div class="flex-column gap-widget">
    <app-application-cost-distribution [refreshFinancialData]="refreshFinancialData"></app-application-cost-distribution>
    <app-application-contract-preview [refreshFinancialData]="refreshFinancialData"></app-application-contract-preview>
</div>
